export default __webpack_public_path__ + "static/media/closet3-1024w.8d8f2e69.png";